import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Dropdown } from "primereact/dropdown";
import Card from "../../../Base/Components/Card/Card";

const CardPreguntaDinamica = ({
  preguntaTexto,
  respuestas = [],
  index = 0,
}) => {
  const tipoGrafio = [
    { id: 1, name: "Barras", value: "bar" },
    { id: 2, name: "Líneas", value: "line" },
    { id: 3, name: "Pie", value: "pie" },
  ];

  const [tipoGrafico, setTipoGrafico] = useState("bar");
  const [chart, setChart] = useState(null);

  const coloresBase = [
    "#D9048E",
    "#0378A6",
    "#A432A6",
    "#049DBF",
    "#D973B5",
    "#EF5350",
    "#AB47BC",
  ];

  const agruparRespuestas = () => {
    const conteo = {};
    respuestas.forEach((resp) => {
      const key = resp.RespuestaTexto || "Sin respuesta";
      conteo[key] = (conteo[key] || 0) + 1;
    });
    return conteo;
  };

  const crearChart = () => {
    const conteo = agruparRespuestas();
    const labels = Object.keys(conteo);
    const data = Object.values(conteo);
    const backgroundColor = labels.map(
      (_, i) => coloresBase[i % coloresBase.length]
    );
    const maxValue = Math.max(...data);
    const maxEjeY = maxValue + 2;

    const total = data.reduce((sum, val) => sum + val, 0);
    const chartData = {
      labels,
      datasets: [
        {
          label: "Cant.",
          data,
          backgroundColor: tipoGrafico === "line" ? "#D9048E" : backgroundColor,
          borderColor: tipoGrafico === "line" ? "#D9048E" : "#fff",
          pointBackgroundColor: "#D9048E",
          fill: false,
        },
      ],
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          color: "#fff",
          anchor: (context) => {
            if (tipoGrafico === "pie") return "center";
            return "center";
          },
          align: (context) => {
            if (tipoGrafico === "pie") return "center";
            return "center";
          },
          formatter: (value, context) => {
            const percentage = ((value / total) * 100).toFixed(1);

            if (tipoGrafico === "pie") {
              return `${percentage}% \n (${value})`;
            }

            // Para gráfico de barras
            return `${percentage}% \n (${value})`;
          },
          font: {
            weight: "bold",
            size: 10,
          },
          clip: false,
        },

        legend: {
          display: tipoGrafico === "pie",
          position: "right",
          labels: {
            usePointStyle: true,
          },
        },
        tooltip: {
          enabled: false, 
          // callbacks: {
          //   label: function (context) {
          //     const label = context.label || "";
          //     const value = context.raw;
          //     const total = context.dataset.data.reduce(
          //       (sum, val) => sum + val,
          //       0
          //     );
          //     const percentage = ((value / total) * 100).toFixed(1);

          //     return [
          //       `Cant: ${value}`,
          //       `Porcentaje: ${percentage}%`,
          //     ];
          //   },
          // },
        },
      },
      interaction: {
        mode: "index",
        intersect: false,
      },
      scales:
        tipoGrafico !== "pie"
          ? {
              y: {
                beginAtZero: true,
                max: maxEjeY,
                precision: 0,
              },
            }
          : {},
    };

    setChart(
      <Chart
        height={480}
        width={650}
        type={tipoGrafico}
        data={chartData}
        options={chartOptions}
        plugins={[ChartDataLabels]}
      />
    );
  };

  useEffect(() => {
    if (respuestas?.length > 0) {
      crearChart();
    }
  }, [respuestas, tipoGrafico]);

  return (
    <div className="my-3">
      <Card
        style={{ background: "#FFF" }}
        contenido={
          <div className="p-3 d-flex flex-column">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold">
                {index + 1} - {preguntaTexto}
              </h5>
              <Dropdown
                value={tipoGrafico}
                options={tipoGrafio}
                onChange={(e) => setTipoGrafico(e.value)}
                optionLabel="name"
                placeholder="Tipo de gráfico"
                style={{ minWidth: "150px", zIndex: 999999999999999 }}
              />
            </div>
            {chart}
          </div>
        }
      />
    </div>
  );
};

export default CardPreguntaDinamica;
